import { Action } from '@/_core/fluxstore/types';
import { uuid } from '@/_core/utils/uuid';
import { StorymapState, Task } from '../../types';
import { getActiveCard } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddNewTask extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddNewTask';

    public _cardId: string = null;
    public constructor(public parentActivityId: string, public order: number, public willBeSavedImmediately: boolean = false) {
        super(AddNewTask.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddNewTask): Promise<boolean> => {
    action._cardId = await uuid.create();
    return true;
};

const reducer = (state: StorymapState, action: AddNewTask): void => {
    const activeCard = getActiveCard();

    state.tasks.filter((x) => x.activityId == action.parentActivityId && x.order >= action.order).forEach((x) => x.order++);

    const task: Task = {
        id: action._cardId,
        activityId: action.parentActivityId,
        title: '',
        description: '',
        color: state.taskColor,
        order: action.order,
        assigneeUserId: null,
        key: null,

        isNew: action.willBeSavedImmediately ? false : true,
        isActive: true,
        activeUsers: [],
        isMultiselected: false,
        isTitleEditing: false,
        isCopied: false,
        isCut: false,
        personaIds: [],
        annotationIds: [],

        hasDescription: false,
        hasAttachment: false,
        hasComment: false,
        hasFeedback: false,
        isSaving: action.willBeSavedImmediately ? true : false,

        isLinkedToIntegrationTool: false,
        linkedUrl: '',
        linkedItemKey: '',
        linkedItemTypeId: null,
        linkedItemTypeName: null,

        createdAt: new Date(),
        createdByUserId: initAppData.currentUser.currentUserShortId,
        lastUpdatedAt: null,
        lastUpdatedByUserId: null,
    };

    state.tasks.push(task);

    // Track newly created card for visibility in hide-unfiltered mode
    if (state.filterState.hideUnfiltered) {
        state.filterState.newlyCreatedCardIds.push(task.id);
    }

    if (activeCard) {
        activeCard.isActive = false;
    }

    return;
};

//@ts-ignore
registerMiddleware(AddNewTask.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddNewTask.ACTION_TYPE, reducer);
